<script setup lang="ts">
defineEmits<{ (e: 'click'): void }>();

defineProps<{
  leadingIconSrc?: string;
  trailingIconSrc?: string;
  text: string;
  type?: 'outlined' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  customStyle?: string;
}>();

function getBoarderStyle(type?: 'outlined' | 'ghost') {
  return type === 'ghost'
    ? ''
    : 'rounded-full border border-light-border dark:border-dark-brd-light ';
}
function getSizeStyle(size?: 'small' | 'medium' | 'large') {
  const buttonSize = size ?? 'medium'; //default is medium
  switch (buttonSize) {
    case 'small':
      return 'h-6 w-fit';
    case 'medium':
      return 'h-10 w-[310px]';
    case 'large':
      return 'h-14 w-[400px]';
  }
}
</script>

<template>
  <button
    type="button"
    @:click="$emit('click')"
    class="flex h-10 w-[310px] items-center justify-center gap-2 px-2 py-6"
    :class="`${getBoarderStyle(type)} ${getSizeStyle(size)} ${customStyle}`"
  >
    <img v-if="leadingIconSrc" :alt="`next`" :src="leadingIconSrc" class="w-[22px]" />
    <p
      class="text-light-primary dark:text-dark-white flex items-center gap-1 font-sans text-sm font-semibold"
    >
      {{ text }}
    </p>
    <img v-if="trailingIconSrc" :alt="`next`" :src="trailingIconSrc" class="w-[22px]" />
  </button>
</template>
